/*
 * @Autor: chentianyang
 * @Date: 2021-04-07 15:08:46
 * @LastEditors: chentianyang
 * @LastEditTime: 2021-08-03 19:30:48
 * @FilePath: \st-teacher-2020\src\store\index.ts
 */
import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import user from './modules/user';
import common from './modules/common';
import lessonDialog from './modules/lessonDialog';
import feedback from './modules/feedback';
import customLecturesDialog from './modules/customLecturesDialog';

const debug = process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    user,
    common,
    lessonDialog,
    feedback,
    customLecturesDialog,
  },
  plugins: debug ? [createLogger()] : [],
});
